<template>
  <div class="log-detail">
    <el-page-header @back="goBack" content="日志详情"></el-page-header>
    <el-row class="mar">
      <el-col :span="6">删除时间：{{info && info.startTime}}</el-col>
      <el-col :span="12">资料类型：{{info && info.channel}}</el-col>
    </el-row>
     <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label">全部（{{info.total || 0}}）</span>
          <Table :list="allList" :pages="pages" @search="fetch_operatorLogDetail"/>
        </el-tab-pane>
        <el-tab-pane label="成功" name="sucess">
          <span slot="label">成功（{{info.successTotal || 0}}）</span>
          <Table :list="sucessList" :pages="pages" @search="fetch_operatorLogDetail"/>
        </el-tab-pane>
        <el-tab-pane label="失败" name="fail">
          <span slot="label">失败（{{info.failureTotal || 0}}）</span>
          <Table :list="failList"  :pages="pages" @search="fetch_operatorLogDetail"/>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Table from './table.vue'
import { getOperatorLogDetail} from '@servers/prod/log/index'
import { mapGetters, mapActions} from 'vuex'

export default {
  components: {
    Table
  },
  props: ['id'],
  data() {
    return {
      activeName: 'all',
      list: [],
      allList: [],
      sucessList: [],
      failList: [],
      info: '',
      pages: {
          total: 0,
          pageNo: 1,
          pageSize: 20,
      },
      status: null
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
  },

  methods: {
    goBack() {
      this.$router.back();
      // this.$router.replace({
      //   name: `${this.routerPrefix}prod_log`
      // })
    },
    async fetch_operatorLogDetail(page) {
      const res = await getOperatorLogDetail({id: this.id, status:this.status, pageNo: page.pageNo || 1, pageSize: page.pageSize || 20});
      if(!res) return;
      switch (this.status) {
        case 0:
          this.failList = res.list;
          break;
        case 1:
          this.sucessList = res.list;
          break;
        default:
          this.allList = res.list
          break;
      }
      this.info = res.info;
      this.pages.total = res.total;
      this.pages.pageNo=page.pageNo || 1; 
      this.pages.pageSize=page.pageSize || 20;
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.pages.pageNo=1;
      let status=null;
      switch (tab.name) {
        case 'all':
          status=null
          break;
        case 'sucess':
          status=1
          break;
        case'fail':
          status=0;
          break;
        default:
          status=null
          break;
      }
      this.status = status;
      this.fetch_operatorLogDetail(this.pages)
    }
  },
  mounted() {
    if(this.id) {
      this.fetch_operatorLogDetail(this.pages)
    }
  }

}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}

</style>
